// import * as types from '../mutation_types'
import storage from '@/storage'

export default {
    setToken: (state, token) => {
        if (!token) {
            storage.remove('token')
        } else {
            storage.set('token', token)
        }
        state.token = token
    },

    setUser: (state, user) => {
        state.error = null
        if (!user) {
            storage.remove('user')
        } else {
            storage.set('user', user)
        }
        state.user = user
    },

    setLoading: (state, loading) => {
        // console.log('setLoading', loading)
        state.loading = loading
    },

    setError: (state, error) => {
        state.loading = false
        state.error = error
    },

    // AUTH_REQUEST: state => {
    //     state.status = 'loading'
    // },

    // AUTH_SUCCESS: (state, data) => {
    //     state.status = 'success'
    //     ;(state.token = data.token), (state.user = data.user)
    // },

    // AUTH_ERROR: (state, message) => {
    //     state.status = 'error'
    // },

    // AUTH_LOGOUT: state => {
    //     ;(state.token = null), (state.user = null)
    // },
    // [types.SET_LANGUAGE](state, data) {
    //     i18n.locale = data
    //     state.language = data
    //     localStorage.setItem('Language', data)
    // },
    // [types.SET_SIMPLESERVICENAME](state, data) {
    //     state.simpleServiceName = data
    //     localStorage.setItem('SimpleServiceName', data)
    // },
    // [types.SET_CHAT](state, data) {
    //     state.activeChat = data
    //     localStorage.setItem('ActiveChat', data)
    // },
}
